import { useEffect, useRef } from "react";

// Pushes `hash` while a sheet is open so the phone back button closes it
// instead of leaving the page; closing any other way pops the entry again.
export default function useSheetHash(open, hash, onClose) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const pushed = useRef(false);
  useEffect(() => {
    if (!open) return;
    window.history.pushState(null, "", `${window.location.pathname}${window.location.search}${hash}`);
    pushed.current = true;
    const onPopState = () => {
      pushed.current = false;
      onCloseRef.current?.();
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
      if (pushed.current) {
        pushed.current = false;
        window.history.back();
      }
    };
  }, [open, hash]);
}